import type { IMasterDataDeductionTypeRepository } from "@src/domain/repositories/masterData";
import type { DeleteAllMasterDataDeductionTypesDTO } from "@src/domain/dto/masterData";

export class DeleteAllMasterDataDeductionTypesUseCase {
  private readonly repository: IMasterDataDeductionTypeRepository;

  constructor(repository: IMasterDataDeductionTypeRepository) {
    this.repository = repository;
  }

  execute(params: DeleteAllMasterDataDeductionTypesDTO) {
    return this.repository.deleteAllDeductionTypes(params);
  }
}
